import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const LegacyAiAdoptionRedirect = () => {
  const location = useLocation();
  return (
    <Navigate replace to={`/ai-leverage/developers${location.search || ''}`} />
  );
};

export default LegacyAiAdoptionRedirect;
